module.exports = __webpack_public_path__ + "static/fonts/AvenirLTStdMedium.813f104.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/quiz-fonts/AvenirLTStdMedium.woff2
// module id = tMX+
// module chunks = 1